import React from 'react';
import { CustomerPaymentProfileContract } from '../../../types/Customer';
import SavedCardSummary from '../../summary/SavedCardSummary';
import Button from '../Button';

export const SavedCardListTestId = 'SavedCardList-input';
export const SavedCardListItemTestId = 'SavedCardListItem-input';
export type SavedCardListProps = {
  paymentProfiles: CustomerPaymentProfileContract[];
  onCardChosen: (id: number) => void;
};

type SavedCardListItemProps = {
  paymentProfile: CustomerPaymentProfileContract;
  onCardChosen: (id: number) => void;
};

const SavedCardListItem: React.FC<SavedCardListItemProps> = ({
  paymentProfile,
  onCardChosen,
}: SavedCardListItemProps) => {
  return (
    <li
      className="flex flex-row justify-between items-center h-16"
      data-testid={SavedCardListItemTestId}
    >
      <div className="w-8/12 ml-4">
        <SavedCardSummary card={paymentProfile.card} />
      </div>
      <div className="justify-self-end mr-2">
        <Button onClick={(): void => onCardChosen(paymentProfile.id as number)}>
          Use This
        </Button>
      </div>
    </li>
  );
};

const SavedCardList: React.FC<SavedCardListProps> = ({
  paymentProfiles,
  onCardChosen,
}: SavedCardListProps) => {
  return (
    <div
      className="container flex flex-col mx-auto w-full border checkout-panel-border rounded-md"
      data-testid={SavedCardListTestId}
    >
      <ul className="flex flex-col divide divide-y">
        {paymentProfiles.map(paymentProfile => {
          return (
            <SavedCardListItem
              key={paymentProfile.id}
              paymentProfile={paymentProfile}
              onCardChosen={onCardChosen}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default SavedCardList;
